const buttons = document.querySelectorAll('.collections_showcase-anchors');
buttons.forEach(button => {
  button.addEventListener('click', () => {
    const target = button.getAttribute('data-btn-target');
    const targetElement = document.getElementById(target);
    const originalScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    targetElement.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
    const restoreScroll = () => {
      window.scrollTo({ top: originalScrollTop, left: window.pageXOffset, behavior: 'auto' });

      window.removeEventListener('scroll', restoreScroll);
    };
    window.addEventListener('scroll', restoreScroll);
  });
});
document.querySelectorAll('button.carat-previous').forEach(button => {
  button.addEventListener('click', event => {
    let container = button.closest('section').querySelector('div.collections_showcase--wrapper');
    container.scrollLeft -= 750;
  })
})
document.querySelectorAll('button.carat-next').forEach(button => {
  button.addEventListener('click', event => {
    let container = button.closest('section').querySelector('div.collections_showcase--wrapper');
    container.scrollLeft += 750;
  })
})